import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { TrackerIntegrationValidationSchema } from "../../schemas/trackerIntegrations/create.schema";

interface UseUpdateTrackerIntegrationProps {
  companyId: string
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateTrackerIntegration = ({companyId, id, onSuccess, onError}: UseUpdateTrackerIntegrationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateTrackerIntegration'],
    mutationFn: async (form: TrackerIntegrationValidationSchema) => {
      const tracker_integration = {
        ...form,
        company_id: companyId,
        option_id: form?.option_id?.value,
      }

      privateAxios.put(`/client/tracker_integrations/${id}`, {tracker_integration})
    },
    onSuccess,
    onError
  });
}

export default useUpdateTrackerIntegration
